import { useMemo, useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Breadcrumbs, CommonSelect } from "components/Common/Common";
import ClientAttachments from "./ClientAttachments";
import { CLIENT_TYPE_KEYS, DOCUMENTS_FILTER_OPTIONS } from "config/constants";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import { getClientBreadCrumbs, userFullName } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useGetClientDetailsQuery } from "store/services/misc";
import { useGetMdtAssessmentDetailsQuery } from "store/services/mdt/assessment";
import { MULTIDISCIPLINARY_SERVICES, MULTIDISCIPLINARY_SERVICES_DETAIL } from "config/paths";

const singleNote = { note: "", disable: false };

const ClientAttachmentsPage = ({ client_id, module, isMdtClient = false, heading = "Notes", buttonName = "Create Note" }) => {
    const navigate = useNavigate()
    const { clientId, clientType } = useParams()
    const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
    const [filter, setFilter] = useState({ resource_type: "" })

    // An mdt client is attached to the mdt caseload only, so the client detail api denies
    // access to it. Its documents come from the mdt detail api instead.
    const clientDetailsQuery = useGetClientDetailsQuery(
        { clientId, clientType },
        { refetchOnMountOrArgChange: true, skip: isMdtClient }
    );

    const mdtDetailsQuery = useGetMdtAssessmentDetailsQuery(
        clientId,
        { refetchOnMountOrArgChange: true, skip: !isMdtClient }
    );

    const {
        data: clientDetails,
        isLoading,
        isFetching,
        refetch,
    } = isMdtClient ? mdtDetailsQuery : clientDetailsQuery;

    const breadcrumbItems = useMemo(() => isMdtClient
        ? [
            { label: "Multidisciplinary Assessments", path: MULTIDISCIPLINARY_SERVICES },
            { label: userFullName(clientDetails) || "Client Details", path: generatePath(MULTIDISCIPLINARY_SERVICES_DETAIL, { id: clientId }) },
            { label: "Documents" },
        ]
        : getClientBreadCrumbs(clientId, clientType, clientDetails, "Documents"), [isMdtClient, clientType, clientDetails, clientId]);

    const handleFilterChange = (field) => (e) => {
        setFilter(prev => ({
            ...prev,
            [field]: e?.value || ""
        }));
    };


    return isLoading ? <LoadingIndicator /> : (
        <>
            <AddClientDocumentsModal
                show={clientsDocumentModal}
                setShow={setClientsDocumentModal}
                clientId={clientId}
                refetch={refetch}
            />
            {isFetching && <LoadingOverlay />}
            <section
                className={`position-relative ClientDetail`}
            >
                <Container fluid>
                    <Row style={{ paddingLeft: '12px' }} className="pt-3">
                        <Col lg="6">
                            <Breadcrumbs items={breadcrumbItems} />
                        </Col>
                    </Row>
                    <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                        <Row className="justify-content-between align-items-end" >
                            <Col lg='6'>
                                <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                    Documents
                                </p>
                            </Col>
                            <Col lg='4'>
                                <div className="d-flex gap-5">
                                    <div className="w-100 reports-v2 d-flex justify-content-end classroom-conslutation">

                                        <div className="d-flex w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Type</label>

                                            <CommonSelect
                                                placeholder={"Select"}
                                                option={DOCUMENTS_FILTER_OPTIONS}
                                                onChange={(e) => handleFilterChange("resource_type")(e)}
                                                value={DOCUMENTS_FILTER_OPTIONS.find(o => o.value === filter.resource_type)}
                                                isFilterV2
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: "100%",
                                                    }),
                                                }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </Col>
                            <Col lg='2' style={{ textAlign: "center" }}>
                                <button
                                    onClick={() => setClientsDocumentModal(true)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                // disabled={isFetching || submitting || copyReportLoading}
                                // isLoading={submitReportLoading || submitting}
                                disabled={clientDetails?.status != "active"}
                                >
                                    Add Documents
                                </button>

                            </Col>
                        </Row>
                    </div>
                    <div className="mt-2">
                        <ClientAttachments
                            filter={filter}
                            isPage={true}
                            resources={clientDetails?.clientResources || []}
                            clientId={clientId}
                            refetch={refetch}
                            clientType={CLIENT_TYPE_KEYS.school}
                        />
                    </div>
                </Container>
            </section>
        </>
    );

};

export default ClientAttachmentsPage;